document.addEventListener('DOMContentLoaded', function() {
	// Инициализация Fancybox
	if (typeof Fancybox !== 'undefined') {
		Fancybox.bind('[data-fancybox="swiper-gallery"]', {
			Carousel: {
				transition: 'slide',
			},
		});
	}

	// Инициализация Swiper
	const swiperEls = document.querySelectorAll('.block-swiper-gallery');
	swiperEls.forEach(function(block) {
		const swiper = block.querySelector('.gallery-swiper');
		const prevBtn = block.querySelector('[data-swiper-prev]');
		const nextBtn = block.querySelector('[data-swiper-next]');

		if (!swiper) return;

		new Swiper(swiper, {
			slidesPerView: 3,
			spaceBetween: 20,
			loop: false,
			speed: 400,
			navigation: {
				prevEl: prevBtn,
				nextEl: nextBtn,
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 10,
				},
				769: {
					slidesPerView: 1,
					spaceBetween: 15,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 26,
				},
			},
		});
	});
});